import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6fdaea76"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "white-margin",
  style: {"margin-bottom":"60px"}
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "com_main_title title_22B" }, " 토론 NOW ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ag_refresher = _resolveComponent("ag-refresher")!
  const _component_ag_box_s = _resolveComponent("ag-box-s")!
  const _component_ag_icon = _resolveComponent("ag-icon")!
  const _component_board_list_all = _resolveComponent("board-list-all")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, { ref: "mainElement" }, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withCtx(() => [
          _createVNode(_component_ag_refresher, {
            slot: "fixed",
            onRefresh: _ctx.doRefresh
          }, null, 8, ["onRefresh"]),
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_ag_box_s, { css: {dp: 'flex'} }, {
              default: _withCtx(() => [
                _createVNode(_component_ag_box_s, { css: {grow: 1} }, {
                  default: _withCtx(() => [
                    _hoisted_2
                  ]),
                  _: 1
                }),
                _createVNode(_component_ag_box_s, {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: 'discussion', 'clickArea':'토론 NOW', 'clickContent': '공유버튼'});_ctx.onShare()})
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ag_icon, {
                      name: "arrowRedo",
                      css: {width: 26, height: 26, color: 'gray6'}
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_board_list_all, { "stock-item-boards-prop": _ctx.stockItemBoards }, null, 8, ["stock-item-boards-prop"])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 512))
}